import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../helpers/export'
import TopPlayersService from './service'

export const getTopPlayersTable = createAsyncThunk(
  'companyAnalysis/industryOverview/topPlayers/getTopPlayersTable',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await TopPlayersService.getTopPlayersTable(params)

      if (res.success) {
        dispatch(
          calculateDefaultUnit({
            screen: SCREEN.INDUSTRY_OVERVIEW,
            getValues: () =>
              res.data
                .map((item) => [
                  { value: item.netRevenue, year: params.Year },
                  { value: item.totalAssets, year: params.Year },
                ])
                .flat(),
          }),
        )

        return res.data
      }

      return rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadTopPlayers = createAsyncThunk(
  'companyAnalysis/industryOverview/topPlayers/downloadTopPlayers',
  async (params) => {
    try {
      const res = await TopPlayersService.downloadTopPlayers(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const getTopYear = createAsyncThunk(
  'companyAnalysis/industryOverview/topPlayers/topYear',
  async (params, { rejectWithValue }) => {
    try {
      const res = await TopPlayersService.getTopYear(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
